import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

// PortalLayout envolve todas as páginas internas do sistema
// Equivale ao frame principal do seu sistema ADVPL (janela mãe com menu e área de trabalho)
//
// Uso no App.jsx:
//   <RotaProtegida>
//     <PortalLayout>
//       <PaginaQualquer />
//     </PortalLayout>
//   </RotaProtegida>

function PortalLayout({ children }) {
  // Menu retrátil: preferência lembrada por navegador (localStorage)
  const [collapsed, setCollapsed] = useState(() => {
    try { return localStorage.getItem('menuRecolhido') === '1'; } catch { return false; }
  });

  const alternarMenu = () => setCollapsed(v => {
    try { localStorage.setItem('menuRecolhido', v ? '0' : '1'); } catch { /* sem storage */ }
    return !v;
  });

  const sidebarWidth = collapsed ? '52px' : '220px';

  return (
    <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#f0f2f7', fontFamily: "'Manrope', sans-serif" }}>
      {/* Menu lateral fixo */}
      <Sidebar collapsed={collapsed} onToggle={alternarMenu} />

      {/* Área principal — empurrada pelo menu */}
      <div style={{ marginLeft: sidebarWidth, flex: 1, transition: 'margin-left 0.25s ease', display: 'flex', flexDirection: 'column' }}>
        {/* Cabeçalho fixo no topo */}
        <Topbar collapsed={collapsed} onToggle={alternarMenu} />

        {/* Conteúdo da página com espaço para o topbar */}
        <main style={{ marginTop: '52px', padding: '24px', flex: 1, position: 'relative' }}>
          {children}
        </main>
      </div>
    </div>
  );
}

export default PortalLayout;
